import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-error-icon",
  props: {
    full: {
      type: Boolean,
      default: false
    }
  }
};
const _hoisted_1 = {
  key: 0,
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.9829 2C7.46291 2 2.98291 6.48 2.98291 12C2.98291 17.52 7.46291 22 12.9829 22C18.5029 22 22.9829 17.52 22.9829 12C22.9829 6.48 18.5029 2 12.9829 2V2ZM13.9829 17H11.9829V15H13.9829V17V17ZM13.9829 13H11.9829V7H13.9829V13V13Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
const _hoisted_4 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_5 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11 15H13V17H11V15ZM11 7H13V13H11V7ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_6 = [
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.full ? (openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3)) : (openBlock(), createElementBlock("svg", _hoisted_4, _hoisted_6));
}
const ErrorIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  ErrorIcon as default
};
//# sourceMappingURL=ErrorIcon.vue.es.js.map
